<ng-container *transloco="let t">
	<div class="flex flex-row pb-2">
		<div class="font-bold">
			{{ allocation().name }}
		</div>
	</div>
	@if (allocation().shareName) {
		{{ t('billing.constant') }}: {{ allocation().shareName }}
	} @else if (allocation().ordinaryType) {
		{{ t('billing.dynamic') }}: {{ t('billing.ordinaryAllocationType.' + allocation().ordinaryType) }}
	} @else if (isCustom()) {
		{{ t('billing.customAllocation') }}
	}
	<div class="flex flex-col text-xs text-gray-400">
		@if (allocation().selectionName) {
			<div>{{ t('billing.parameterValue.SELECTION') }}: {{ allocation().selectionName }}</div>
		}
	</div>
</ng-container>
